import gsap from "../../js/gsap/gsap.min.js";
import { Flip } from "../../js/gsap/Flip.min.js";

gsap.registerPlugin(Flip);

(function () {

const grid = document.querySelector("#news-grid");
if (!grid) return;

const loadBtn = document.querySelector("#news-load-more");
const filters = [...document.querySelectorAll(".news-filter a")];
const allBtn  = document.querySelector('.news-filter a[data-term="0"]');

let page = 1;
let activeTerms = [];
let busy = false;                     // prevents overlapping Flips

function cards() {
    return gsap.utils.toArray("#news-grid .news-card");
}

function matches(card) {
    return !activeTerms.length ||
        activeTerms.some(t => card.classList.contains("term-" + t));
}

function applyFilter() {
    if (busy) return;
    busy = true;

    const items = cards();
    const state = Flip.getState(items);          // capture BEFORE display change

    items.forEach(item => {
        item.style.display = matches(item) ? "" : "none";
    });

    Flip.from(state, {
        duration: 0.7,
        scale: true,
        absolute: true,
        ease: "power1.inOut",
        onEnter: els => gsap.fromTo(els,
            { opacity: 0, scale: 0 },
            { opacity: 1, scale: 1, duration: 0.7 }),
        onLeave: els => gsap.to(els,
            { opacity: 0, scale: 0, duration: 0.7 }),
        onComplete: () => { busy = false; }
    });
}

filters.forEach(btn => {
    btn.addEventListener("click", e => {
        e.preventDefault();
        const term = btn.dataset.term;

        if (term === "0") {
            filters.forEach(el => el.classList.remove("active"));
            allBtn.classList.add("active");
            activeTerms = [];
        } else {
            allBtn.classList.remove("active");
            btn.classList.toggle("active");
            activeTerms = filters
                .filter(el => el !== allBtn && el.classList.contains("active"))
                .map(el => el.dataset.term);
            if (!activeTerms.length) allBtn.classList.add("active");
        }

        applyFilter();
    });
});

// --- load more: append in flow, animate in place (NO Flip) ---
async function loadMore() {
    page++;

    const fd = new FormData();
    fd.append("action", "filter_news");
    fd.append("nonce", window.newsAjax.nonce);
    fd.append("paged", page);

    const res  = await fetch(window.newsAjax.ajax_url, { method: "POST", body: fd });
    const data = await res.json();
    if (data?.html == null) return;

    const tmp = document.createElement("div");
    tmp.innerHTML = data.html;
    const incoming = [...tmp.querySelectorAll(".news-card")];

    // append at the end, honour current filter, then fade/scale in IN PLACE
    const added = [];
    incoming.forEach(card => {
        card.style.display = matches(card) ? "" : "none";
        grid.appendChild(card);
        if (card.style.display !== "none") added.push(card);
    });

    gsap.from(added, {
        opacity: 0,
        scale: 0.85,
        y: 20,
        duration: 0.6,
        ease: "power1.out",
        stagger: 0.05
    });

    if (loadBtn) loadBtn.style.display = page < data.max_pages ? "" : "none";
}

loadBtn?.addEventListener("click", loadMore);

})();
